var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"custom-border option_button custom_flat_button",attrs:{"small":""}},on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}])},[_c('v-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }